import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useRestContext } from 'components/form/RestInputContext';
import FormSelect from 'components/form/FormSelect';
import { useCallback, useState } from 'react';
import { DynamicObjectType } from 'types/commons';
import { getOrderByIdApi } from 'api/orders';
function OrderProductSelect({ handleGetProducts, handleConvertData }) {
  const { t } = useTranslation();
  const { form } = useRestContext();

  const [products, setProducts] = useState<DynamicObjectType[]>([]);
  const [dataForForm, setDataForForm] = useState<DynamicObjectType>();

  const getAllVariants = useCallback((orderId) => {
    getOrderByIdApi(orderId)
      .then((res) => {
        if (Array.isArray(res?.items) && res?.items?.length > 0) {
          const data = handleConvertData(res?.items);
          setProducts(data);
        }
        setDataForForm({
          address: res?.address,
          customer: res?.customer,
          orderNumber: res?.orderNumber,
          paymentType: res?.paymentType,
        });
      })
      .finally(() => {})
      .catch(() => null);
  }, []);

  const handleSearch = () => {
    form.setFieldsValue({
      pickupInformation: dataForForm?.address
        ? {
            addressLine1: '',
            addressLine2: '',
            ...dataForForm?.address,
          }
        : null,
      customer: dataForForm?.customer,
      orderNumber: dataForForm?.orderNumber,
      paymentType: dataForForm?.paymentType,
    });
    handleGetProducts(products);
  };

  return (
    <OrderProductSelectWrapper className="d-flex align-items-end w-full">
      <div className="flex-1 select-product">
        <FormSelect
          name="orderId"
          reference={{
            labelProp: 'orderNumber',
            model: 'orders/list/create-order-return',
            searchKey: 'orderNumber',
            initFilters: {
              join: ['orderReturn'],
              rawQuery: {
                $and: [
                  {
                    statusOms: {
                      $eq: 'DELIVERY_SUCCESS',
                    },
                  },
                  {
                    isMarketPlace: {
                      $eq: 'false',
                    },
                  },
                  {
                    paymentType: {
                      $ne: 'fundiin',
                    },
                  },
                  {
                    orderType: {
                      $ne: 'OFFLINE',
                    },
                  },
                  // {
                  //   $or: [
                  //     {
                  //       'orderReturn.status': {
                  //         $eq: 'CANCELLED',
                  //       },
                  //     },
                  //     {
                  //       'orderReturn.id': {
                  //         $isnull: 'true',
                  //       },
                  //     },
                  //   ],
                  // },
                ],
              },
              // filters: [
              //   {
              //     condition: 'and',
              //     key: 'statusOms',
              //     operator: 'eq',
              //     value: 'DELIVERY_SUCCESS',
              //   },
              //   {
              //     condition: 'and',
              //     key: 'isMarketPlace',
              //     operator: 'eq',
              //     value: 'false',
              //   },
              //   {
              //     condition: 'and',
              //     key: 'paymentType',
              //     operator: 'ne',
              //     value: 'fundiin',
              //   },
              //   {
              //     condition: 'and',
              //     key: 'orderReturn.status',
              //     operator: 'ne',
              //     value: 'CANCELLED',
              //   },
              // ],
            },
            operator: 'contL',
            allowClear: true,
          }}
          placeholder={t('ordersReturn.searchOrder')}
          extraOnChage={(e) => {
            getAllVariants(e);
          }}
        />
      </div>

      <Button
        className="ml-5 mb-5"
        type="primary"
        onClick={() => handleSearch()}
      >
        {t('button.searchVariant')}
      </Button>
    </OrderProductSelectWrapper>
  );
}

const OrderProductSelectWrapper = styled.div`
  .select-product {
    width: 80%;
  }
`;

export default OrderProductSelect;
